import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import backGroundImage from '@img/bg-login.jpg'
import kbLogo from '@img/KB-monogramma.svg'
import powered from '@img/powered.svg'
import LoginForm from './LoginForm'

/**
 * componente Pagina di login
 * @component
 */
export const Login: React.FC = () => {
  return (
    <Container>
      <KBLogo src={kbLogo} />
      <LoginForm />
      <Powered src={powered} />
    </Container>
  )
}

//region STYLE
const Container = styled.div`
  display: grid;
  height: 100vh;
  background: url(${backGroundImage}) no-repeat center center;
  background-size: cover;
  width: 100%;
  gap: 38px;
`
const KBLogo = styled.img`
  position: absolute;
  right: 2.08%;
  top: 5.43%;
  z-index: 11;
  height: 40px;
`
const Powered = styled.img`
  position: fixed;
  bottom: 24px;
  right: 20px;
  height: 14px;
`
//endregion
